import { Box, Typography } from "@mui/material";
import {
  getPrettyDate,
  getPrettyDateTime,
  useLocalTime,
} from "../../../../../../utils/timestamp";
import IntegrationImage from "../../../../integrations/components/IntegrationImage";
import { IntegrationsMapping } from "../../../../integrations/IntegrationsMapping";
import TextIntegrationStyle from "../../TextIntegrationStyle";

const NonHumanIdentityHistoryView = ({ entityData }) => {
  const showLocalTime = useLocalTime();
  return (
    <Box display={"flex"} flexDirection={"column"} gap={2}>
      {(entityData?.okta_token_data?.creation_datetime ||
        entityData?.aws_common_data?.creation_datetime ||
        entityData?.github_secret_data?.creation_date ||
        entityData?.github_pat_data?.created_at ||
        entityData?.azure_keyvault_resource_data?.creation_date ||
        entityData?.snowflake_service_user?.creation_date ||
        entityData?.microsoft_entra_id_application_data?.created_date ||
        entityData?.gitlab_access_token_data?.created_at ||
        entityData?.github_org_app_data?.created_at ||
        entityData?.salesforce_oauth_token_data?.created_date ||
        entityData?.microsoft_active_directory_service_user_data
          ?.creation_date) && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} flexDirection={"column"} gap={1}>
            <Box
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              gap={1}
            >
              <Typography variant={"subtitle2"}>Creation Date</Typography>
            </Box>
            <Box ml={3} display={"flex"}>
              {entityData?.okta_token_data?.creation_datetime && (
                <TextIntegrationStyle
                  title={
                    <Box
                      display={"flex"}
                      alignItems={"center"}
                      flexDirection={"row"}
                    >
                      <IntegrationImage
                        name={"okta"}
                        width={"16px"}
                        newLogo={true}
                      />
                    </Box>
                  }
                  value={getPrettyDate(
                    entityData.okta_token_data?.creation_datetime.timestamp_utc,
                    showLocalTime
                  )}
                ></TextIntegrationStyle>
              )}
              {entityData?.aws_common_data?.creation_datetime && (
                <TextIntegrationStyle
                  title={
                    <Box
                      display={"flex"}
                      flexDirection={"row"}
                      alignItems={"center"}
                      gap={1}
                    >
                      <IntegrationImage
                        name={"aws"}
                        width={"16px"}
                        newLogo={true}
                      />
                    </Box>
                  }
                  value={getPrettyDate(
                    entityData.aws_common_data?.creation_datetime.timestamp_utc,
                    showLocalTime
                  )}
                ></TextIntegrationStyle>
              )}
              {entityData?.github_secret_data?.creation_date && (
                <TextIntegrationStyle
                  title={
                    <Box
                      display={"flex"}
                      flexDirection={"row"}
                      alignItems={"center"}
                      gap={1}
                    >
                      <IntegrationImage
                        name={"github"}
                        width={"16px"}
                        newLogo={true}
                      />
                    </Box>
                  }
                  value={getPrettyDate(
                    entityData?.github_secret_data?.creation_date.timestamp_utc,
                    showLocalTime
                  )}
                ></TextIntegrationStyle>
              )}
              {entityData?.github_pat_data?.created_at && (
                <TextIntegrationStyle
                  title={
                    <Box
                      display={"flex"}
                      flexDirection={"row"}
                      alignItems={"center"}
                      gap={1}
                    >
                      <IntegrationImage
                        name={"github"}
                        width={"16px"}
                        newLogo={true}
                      />
                    </Box>
                  }
                  value={getPrettyDate(
                    entityData?.github_pat_data?.created_at.timestamp_utc,
                    showLocalTime
                  )}
                ></TextIntegrationStyle>
              )}
              {entityData?.azure_keyvault_resource_data?.creation_date && (
                <TextIntegrationStyle
                  title={
                    <Box
                      display={"flex"}
                      alignItems={"center"}
                      flexDirection={"row"}
                    >
                      <IntegrationImage
                        name={"azure"}
                        width={"16px"}
                        newLogo={true}
                      />
                    </Box>
                  }
                  value={getPrettyDate(
                    entityData.azure_keyvault_resource_data.creation_date
                      .timestamp_utc,
                    showLocalTime
                  )}
                ></TextIntegrationStyle>
              )}
              {entityData?.snowflake_service_user?.creation_date && (
                <TextIntegrationStyle
                  title={
                    <Box
                      display={"flex"}
                      alignItems={"center"}
                      flexDirection={"row"}
                    >
                      <IntegrationImage
                        name={"snowflake"}
                        width={"16px"}
                        newLogo={true}
                      />
                    </Box>
                  }
                  value={getPrettyDate(
                    entityData.snowflake_service_user.creation_date
                      .timestamp_utc,
                    showLocalTime
                  )}
                ></TextIntegrationStyle>
              )}
              {entityData?.microsoft_entra_id_application_data
                ?.created_date && (
                <TextIntegrationStyle
                  title={
                    <Box
                      display={"flex"}
                      alignItems={"center"}
                      flexDirection={"row"}
                    >
                      <IntegrationImage
                        name={"microsoft_entra_id"}
                        width={"16px"}
                        newLogo={true}
                      />
                    </Box>
                  }
                  value={getPrettyDate(
                    entityData.microsoft_entra_id_application_data.created_date
                      .timestamp_utc,
                    showLocalTime
                  )}
                ></TextIntegrationStyle>
              )}
              {entityData?.gitlab_access_token_data?.created_at && (
                <TextIntegrationStyle
                  title={
                    <Box
                      display={"flex"}
                      alignItems={"center"}
                      flexDirection={"row"}
                    >
                      <IntegrationImage
                        name={"gitlab"}
                        width={"16px"}
                        newLogo={true}
                      />
                    </Box>
                  }
                  value={getPrettyDate(
                    entityData.gitlab_access_token_data.created_at
                      .timestamp_utc,
                    showLocalTime
                  )}
                ></TextIntegrationStyle>
              )}
              {entityData?.github_org_app_data?.created_at && (
                <TextIntegrationStyle
                  title={
                    <Box
                      display={"flex"}
                      alignItems={"center"}
                      flexDirection={"row"}
                    >
                      <IntegrationImage
                        name={"github"}
                        width={"16px"}
                        newLogo={true}
                      />
                    </Box>
                  }
                  value={getPrettyDate(
                    entityData.github_org_app_data.created_at.timestamp_utc,
                    showLocalTime
                  )}
                ></TextIntegrationStyle>
              )}
              {entityData?.salesforce_oauth_token_data?.created_date && (
                <TextIntegrationStyle
                  title={
                    <Box display={"flex"} gap={1}>
                      <IntegrationImage
                        name={IntegrationsMapping.salesforce.codeName}
                        width={"16px"}
                        newLogo={true}
                      />
                    </Box>
                  }
                  value={getPrettyDate(
                    entityData.salesforce_oauth_token_data.created_date
                      .timestamp_utc,
                    showLocalTime
                  )}
                />
              )}
              {entityData?.microsoft_active_directory_service_user_data
                ?.creation_date && (
                <TextIntegrationStyle
                  title={
                    <Box display={"flex"} gap={1}>
                      <IntegrationImage
                        name={
                          IntegrationsMapping.microsoft_active_directory
                            .codeName
                        }
                        width={"16px"}
                        newLogo={true}
                      />
                    </Box>
                  }
                  value={getPrettyDateTime(
                    entityData.microsoft_active_directory_service_user_data
                      .creation_date.timestamp_utc,
                    showLocalTime
                  )}
                />
              )}
            </Box>
          </Box>
        </Box>
      )}
      {(entityData?.azure_keyvault_resource_data?.expiration_date ||
        entityData?.okta_token_data?.expiration_datetime ||
        entityData?.github_pat_data ||
        entityData?.gitlab_access_token_data?.expires_at) && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} flexDirection={"column"} gap={1}>
            <Box
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              gap={1}
            >
              <Typography variant={"subtitle2"}>Expiration date</Typography>
            </Box>
            <Box ml={3} display={"flex"}>
              {entityData?.okta_token_data?.expiration_datetime && (
                <TextIntegrationStyle
                  title={
                    <Box
                      display={"flex"}
                      alignItems={"center"}
                      flexDirection={"row"}
                    >
                      <IntegrationImage
                        name={"okta"}
                        width={"16px"}
                        newLogo={true}
                      />
                    </Box>
                  }
                  value={getPrettyDate(
                    entityData.okta_token_data?.expiration_datetime
                      .timestamp_utc,
                    showLocalTime
                  )}
                ></TextIntegrationStyle>
              )}
              {entityData?.azure_keyvault_resource_data?.expiration_date && (
                <TextIntegrationStyle
                  title={
                    <Box
                      display={"flex"}
                      alignItems={"center"}
                      flexDirection={"row"}
                    >
                      <IntegrationImage
                        name={"azure"}
                        width={"16px"}
                        newLogo={true}
                      />
                    </Box>
                  }
                  value={getPrettyDate(
                    entityData?.azure_keyvault_resource_data?.expiration_date
                      .timestamp_utc,
                    showLocalTime
                  )}
                ></TextIntegrationStyle>
              )}
              {entityData?.github_pat_data && (
                <TextIntegrationStyle
                  title={
                    <Box
                      display={"flex"}
                      alignItems={"center"}
                      flexDirection={"row"}
                    >
                      <IntegrationImage
                        name={"github"}
                        width={"16px"}
                        newLogo={true}
                      />
                    </Box>
                  }
                  value={
                    entityData?.github_pat_data?.expired_date
                      ? getPrettyDate(
                          entityData?.github_pat_data?.expired_date
                            .timestamp_utc,
                          showLocalTime
                        )
                      : "Never"
                  }
                ></TextIntegrationStyle>
              )}
              {entityData?.gitlab_access_token_data?.expires_at && (
                <TextIntegrationStyle
                  title={
                    <Box
                      display={"flex"}
                      alignItems={"center"}
                      flexDirection={"row"}
                    >
                      <IntegrationImage
                        name={"gitlab"}
                        width={"16px"}
                        newLogo={true}
                      />
                    </Box>
                  }
                  value={
                    entityData?.gitlab_access_token_data?.expires_at
                      ? getPrettyDate(
                          entityData?.gitlab_access_token_data?.expires_at
                            .timestamp_utc,
                          showLocalTime
                        )
                      : "Never"
                  }
                ></TextIntegrationStyle>
              )}
            </Box>
          </Box>
        </Box>
      )}
      {(entityData?.aws_secret_data?.last_changed_datetime ||
        entityData?.okta_token_data?.last_updated_datetime ||
        entityData?.github_secret_data?.last_updated_date ||
        entityData?.azure_keyvault_resource_data?.last_updated_date ||
        entityData?.gitlab_access_token_data?.last_used_at ||
        entityData?.slack_saas_nhi_data?.updated ||
        entityData?.microsoft_active_directory_service_user_data
          ?.last_change_date) && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant="subtitle2" fontWeight={"500"}>
              Last Changed
            </Typography>
          </Box>
          <Box ml={3} display={"flex"}>
            {entityData?.aws_secret_data?.last_changed_datetime && (
              <TextIntegrationStyle
                title={
                  <Box
                    display={"flex"}
                    alignItems={"center"}
                    flexDirection={"row"}
                  >
                    <IntegrationImage
                      name={"aws"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={getPrettyDate(
                  entityData.aws_secret_data?.last_changed_datetime
                    .timestamp_utc,
                  showLocalTime
                )}
              ></TextIntegrationStyle>
            )}
            {entityData?.okta_token_data?.last_updated_datetime && (
              <TextIntegrationStyle
                title={
                  <Box
                    display={"flex"}
                    alignItems={"center"}
                    flexDirection={"row"}
                  >
                    <IntegrationImage
                      name={"okta"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={getPrettyDate(
                  entityData.okta_token_data?.last_updated_datetime
                    .timestamp_utc,
                  showLocalTime
                )}
              ></TextIntegrationStyle>
            )}
            {entityData?.github_secret_data?.last_updated_date && (
              <TextIntegrationStyle
                title={
                  <Box
                    display={"flex"}
                    alignItems={"center"}
                    flexDirection={"row"}
                  >
                    <IntegrationImage
                      name={"github"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={getPrettyDate(
                  entityData?.github_secret_data?.last_updated_date
                    .timestamp_utc,
                  showLocalTime
                )}
              ></TextIntegrationStyle>
            )}
            {entityData?.azure_keyvault_resource_data?.last_updated_date && (
              <TextIntegrationStyle
                title={
                  <Box
                    display={"flex"}
                    alignItems={"center"}
                    flexDirection={"row"}
                  >
                    <IntegrationImage
                      name={"azure"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={getPrettyDate(
                  entityData.azure_keyvault_resource_data.last_updated_date
                    .timestamp_utc,
                  showLocalTime
                )}
              ></TextIntegrationStyle>
            )}
            {entityData?.gitlab_access_token_data?.last_used_at && (
              <TextIntegrationStyle
                title={
                  <Box
                    display={"flex"}
                    alignItems={"center"}
                    flexDirection={"row"}
                  >
                    <IntegrationImage
                      name={"gitlab"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={getPrettyDate(
                  entityData?.gitlab_access_token_data?.last_used_at
                    .timestamp_utc,
                  showLocalTime
                )}
              ></TextIntegrationStyle>
            )}
            {entityData?.slack_saas_nhi_data?.updated && (
              <TextIntegrationStyle
                title={
                  <Box
                    display={"flex"}
                    alignItems={"center"}
                    flexDirection={"row"}
                  >
                    <IntegrationImage
                      name={"slack_saas"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={getPrettyDate(
                  entityData?.slack_saas_nhi_data?.updated.timestamp_utc,
                  showLocalTime
                )}
              ></TextIntegrationStyle>
            )}
            {entityData?.microsoft_active_directory_service_user_data
              ?.last_change_date && (
              <TextIntegrationStyle
                title={
                  <Box
                    display={"flex"}
                    alignItems={"center"}
                    flexDirection={"row"}
                  >
                    <IntegrationImage
                      name={"microsoft_active_directory"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={getPrettyDateTime(
                  entityData?.microsoft_active_directory_service_user_data
                    ?.last_change_date.timestamp_utc,
                  showLocalTime
                )}
              ></TextIntegrationStyle>
            )}
          </Box>
        </Box>
      )}{" "}
      {entityData?.github_org_app_data?.updated_at && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant="subtitle2" fontWeight={"500"}>
              Last Updated
            </Typography>
          </Box>
          <Box ml={3} display={"flex"}>
            {entityData?.github_org_app_data?.updated_at && (
              <TextIntegrationStyle
                title={
                  <Box
                    display={"flex"}
                    alignItems={"center"}
                    flexDirection={"row"}
                  >
                    <IntegrationImage
                      name={"github"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={getPrettyDate(
                  entityData?.github_org_app_data?.updated_at.timestamp_utc,
                  showLocalTime
                )}
              ></TextIntegrationStyle>
            )}
          </Box>
        </Box>
      )}
      {entityData?.azure_keyvault_resource_data?.not_before_date && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant="subtitle2" fontWeight={"500"}>
              Activation Date
            </Typography>
          </Box>
          <Box ml={3} display={"flex"}>
            {entityData?.azure_keyvault_resource_data?.not_before_date && (
              <TextIntegrationStyle
                title={
                  <Box
                    display={"flex"}
                    alignItems={"center"}
                    flexDirection={"row"}
                  >
                    <IntegrationImage
                      name={"azure"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={getPrettyDate(
                  entityData?.azure_keyvault_resource_data?.not_before_date
                    .timestamp_utc,
                  showLocalTime
                )}
              ></TextIntegrationStyle>
            )}
          </Box>
        </Box>
      )}
      {(entityData?.snowflake_service_user?.last_success_login ||
        entityData?.microsoft_active_directory_service_user_data
          ?.last_logon_date) && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} flexDirection={"column"} gap={1}>
            <Box
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              gap={1}
            >
              <Typography variant="subtitle2" fontWeight={"500"}>
                Last Successful Login
              </Typography>
            </Box>
            <Box ml={3} display={"flex"}>
              {entityData?.snowflake_service_user?.last_success_login && (
                <TextIntegrationStyle
                  title={
                    <Box
                      display={"flex"}
                      alignItems={"center"}
                      flexDirection={"row"}
                    >
                      <IntegrationImage
                        name={"snowflake"}
                        width={"16px"}
                        newLogo={true}
                      />
                    </Box>
                  }
                  value={getPrettyDate(
                    entityData?.snowflake_service_user?.last_success_login
                      .timestamp_utc,
                    showLocalTime
                  )}
                ></TextIntegrationStyle>
              )}
              {entityData?.microsoft_active_directory_service_user_data
                ?.last_logon_date && (
                <TextIntegrationStyle
                  title={
                    <Box
                      display={"flex"}
                      alignItems={"center"}
                      flexDirection={"row"}
                    >
                      <IntegrationImage
                        name={"microsoft_active_directory"}
                        width={"16px"}
                        newLogo={true}
                      />
                    </Box>
                  }
                  value={getPrettyDateTime(
                    entityData?.microsoft_active_directory_service_user_data
                      ?.last_logon_date.timestamp_utc,
                    showLocalTime
                  )}
                ></TextIntegrationStyle>
              )}
            </Box>
          </Box>
        </Box>
      )}
      {(entityData?.snowflake_service_user?.password_last_set_time ||
        entityData?.microsoft_active_directory_service_user_data
          ?.last_password_change_date) && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant="subtitle2" fontWeight={"500"}>
              Last Password Change
            </Typography>
          </Box>
          <Box ml={3} display={"flex"}>
            {entityData?.snowflake_service_user?.password_last_set_time && (
              <TextIntegrationStyle
                title={
                  <Box
                    display={"flex"}
                    alignItems={"center"}
                    flexDirection={"row"}
                  >
                    <IntegrationImage
                      name={"snowflake"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={
                  entityData?.snowflake_service_user?.password_last_set_time
                    ? entityData?.snowflake_service_user?.password_last_set_time
                    : "Password Never Changed"
                }
              ></TextIntegrationStyle>
            )}
            {entityData?.microsoft_active_directory_service_user_data
              ?.last_password_change_date && (
              <TextIntegrationStyle
                title={
                  <Box
                    display={"flex"}
                    alignItems={"center"}
                    flexDirection={"row"}
                  >
                    <IntegrationImage
                      name={"microsoft_active_directory"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={
                  entityData?.microsoft_active_directory_service_user_data
                    ?.last_password_change_date
                    ? getPrettyDateTime(
                        entityData?.microsoft_active_directory_service_user_data
                          ?.last_password_change_date.timestamp_utc,
                        showLocalTime
                      )
                    : "Password Never Changed"
                }
              ></TextIntegrationStyle>
            )}
          </Box>
        </Box>
      )}
      {(entityData?.github_pat_data?.last_used_at ||
        entityData?.mongo_atlas_api_key_data?.last_used ||
        entityData?.salesforce_oauth_token_data?.last_used_date) && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant="subtitle2" fontWeight={"500"}>
              Last Used Date
            </Typography>
          </Box>
          {entityData?.github_pat_data?.last_used_at && (
            <Box ml={3} display={"flex"}>
              <TextIntegrationStyle
                title={
                  <Box
                    display={"flex"}
                    alignItems={"center"}
                    flexDirection={"row"}
                  >
                    <IntegrationImage
                      name={"github"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={getPrettyDate(
                  entityData?.github_pat_data?.last_used_at.timestamp_utc,
                  showLocalTime
                )}
              ></TextIntegrationStyle>
            </Box>
          )}
          {entityData?.mongo_atlas_api_key_data?.last_used && (
            <Box ml={3} display={"flex"}>
              <TextIntegrationStyle
                title={
                  <Box
                    display={"flex"}
                    alignItems={"center"}
                    flexDirection={"row"}
                  >
                    <IntegrationImage
                      name={"mongoatlas"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={getPrettyDate(
                  entityData?.mongo_atlas_api_key_data?.last_used.timestamp_utc,
                  showLocalTime
                )}
              ></TextIntegrationStyle>
            </Box>
          )}
          {entityData?.salesforce_oauth_token_data?.last_used_date && (
            <Box ml={3} display={"flex"}>
              <TextIntegrationStyle
                title={
                  <Box display={"flex"} gap={1}>
                    <IntegrationImage
                      name={IntegrationsMapping.salesforce.codeName}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={getPrettyDate(
                  entityData.salesforce_oauth_token_data.last_used_date
                    .timestamp_utc,
                  showLocalTime
                )}
              />
            </Box>
          )}
        </Box>
      )}
      {entityData?.atlassian_api_key_data?.last_active_at && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant="subtitle2" fontWeight={"500"}>
              Last Used Date
            </Typography>
          </Box>
          <TextIntegrationStyle
            title={
              <Box display={"flex"} alignItems={"center"} flexDirection={"row"}>
                <IntegrationImage
                  name={"atlassian"}
                  width={"16px"}
                  newLogo={true}
                />
              </Box>
            }
            value={getPrettyDate(
              entityData?.atlassian_api_key_data?.last_active_at.timestamp_utc,
              showLocalTime
            )}
          ></TextIntegrationStyle>
        </Box>
      )}
      {entityData?.atlassian_api_key_data?.created_at && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant="subtitle2" fontWeight={"500"}>
              Created At
            </Typography>
          </Box>
          <TextIntegrationStyle
            title={
              <Box display={"flex"} alignItems={"center"} flexDirection={"row"}>
                <IntegrationImage
                  name={"atlassian"}
                  width={"16px"}
                  newLogo={true}
                />
              </Box>
            }
            value={getPrettyDate(
              entityData?.atlassian_api_key_data?.created_at.timestamp_utc,
              showLocalTime
            )}
          ></TextIntegrationStyle>
        </Box>
      )}
      {entityData?.atlassian_api_key_data?.expires_at && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant="subtitle2" fontWeight={"500"}>
              Expires At
            </Typography>
          </Box>
          <TextIntegrationStyle
            title={
              <Box display={"flex"} alignItems={"center"} flexDirection={"row"}>
                <IntegrationImage
                  name={"atlassian"}
                  width={"16px"}
                  newLogo={true}
                />
              </Box>
            }
            value={getPrettyDate(
              entityData?.atlassian_api_key_data?.expires_at.timestamp_utc,
              showLocalTime
            )}
          ></TextIntegrationStyle>
        </Box>
      )}
      {entityData?.claude_api_keys_data?.created_at && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant="subtitle2" fontWeight={"500"}>
              Created Date
            </Typography>
          </Box>
          <TextIntegrationStyle
            title={
              <Box display={"flex"} alignItems={"center"} flexDirection={"row"}>
                <IntegrationImage
                  name={"claude"}
                  width={"16px"}
                  newLogo={true}
                />
              </Box>
            }
            value={getPrettyDate(
              entityData.claude_api_keys_data.created_at.timestamp_utc,
              showLocalTime
            )}
          ></TextIntegrationStyle>
        </Box>
      )}
      {entityData?.atlassian_api_token_data?.last_active_at && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant="subtitle2" fontWeight={"500"}>
              Last Used Date
            </Typography>
          </Box>
          <TextIntegrationStyle
            title={
              <Box display={"flex"} alignItems={"center"} flexDirection={"row"}>
                <IntegrationImage
                  name={"atlassian"}
                  width={"16px"}
                  newLogo={true}
                />
              </Box>
            }
            value={getPrettyDate(
              entityData?.atlassian_api_token_data?.last_active_at
                .timestamp_utc,
              showLocalTime
            )}
          ></TextIntegrationStyle>
        </Box>
      )}
      {entityData?.atlassian_api_token_data?.created_at && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant="subtitle2" fontWeight={"500"}>
              Created At
            </Typography>
          </Box>
          <TextIntegrationStyle
            title={
              <Box display={"flex"} alignItems={"center"} flexDirection={"row"}>
                <IntegrationImage
                  name={"atlassian"}
                  width={"16px"}
                  newLogo={true}
                />
              </Box>
            }
            value={getPrettyDate(
              entityData?.atlassian_api_token_data?.created_at.timestamp_utc,
              showLocalTime
            )}
          ></TextIntegrationStyle>
        </Box>
      )}
      {entityData?.atlassian_api_token_data?.expires_at && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant="subtitle2" fontWeight={"500"}>
              Expires At
            </Typography>
          </Box>
          <TextIntegrationStyle
            title={
              <Box display={"flex"} alignItems={"center"} flexDirection={"row"}>
                <IntegrationImage
                  name={"atlassian"}
                  width={"16px"}
                  newLogo={true}
                />
              </Box>
            }
            value={getPrettyDate(
              entityData?.atlassian_api_token_data?.expires_at.timestamp_utc,
              showLocalTime
            )}
          ></TextIntegrationStyle>
        </Box>
      )}
      {entityData?.zendesk_api_token_data?.created_at && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant="subtitle2" fontWeight={"500"}>
              Created At
            </Typography>
          </Box>
          <TextIntegrationStyle
            title={
              <Box display={"flex"} alignItems={"center"} flexDirection={"row"}>
                <IntegrationImage
                  name={"zendesk"}
                  width={"16px"}
                  newLogo={true}
                />
              </Box>
            }
            value={getPrettyDate(
              entityData?.zendesk_api_token_data?.created_at.timestamp_utc,
              showLocalTime
            )}
          ></TextIntegrationStyle>
        </Box>
      )}
      {entityData?.zendesk_api_token_data?.last_used && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant="subtitle2" fontWeight={"500"}>
              Last Used Date
            </Typography>
          </Box>
          <TextIntegrationStyle
            title={
              <Box display={"flex"} alignItems={"center"} flexDirection={"row"}>
                <IntegrationImage
                  name={"zendesk"}
                  width={"16px"}
                  newLogo={true}
                />
              </Box>
            }
            value={getPrettyDate(
              entityData?.zendesk_api_token_data?.last_used.timestamp_utc,
              showLocalTime
            )}
          ></TextIntegrationStyle>
        </Box>
      )}
      {entityData?.openai_admin_api_key_data?.created_at && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant="subtitle2" fontWeight={"500"}>
              Created At
            </Typography>
          </Box>
          <TextIntegrationStyle
            title={
              <Box display={"flex"} alignItems={"center"} flexDirection={"row"}>
                <IntegrationImage
                  name={"openai"}
                  width={"16px"}
                  newLogo={true}
                />
              </Box>
            }
            value={getPrettyDate(
              entityData?.openai_admin_api_key_data?.created_at.timestamp_utc,
              showLocalTime
            )}
          ></TextIntegrationStyle>
        </Box>
      )}
      {entityData?.openai_admin_api_key_data?.last_used_at && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant="subtitle2" fontWeight={"500"}>
              Last Used Date
            </Typography>
          </Box>
          <TextIntegrationStyle
            title={
              <Box display={"flex"} alignItems={"center"} flexDirection={"row"}>
                <IntegrationImage
                  name={"openai"}
                  width={"16px"}
                  newLogo={true}
                />
              </Box>
            }
            value={getPrettyDate(
              entityData?.openai_admin_api_key_data?.last_used_at.timestamp_utc,
              showLocalTime
            )}
          ></TextIntegrationStyle>
        </Box>
      )}
    </Box>
  );
};

export default NonHumanIdentityHistoryView;
